export function initGuideAction(payload) {
  return function somename(dispatch, getState) {
    dispatch({
      type: 'INIT_GUIDE',
      payload,
    });
  };
}
